import { render, staticRenderFns } from "./CreateXNusantaraModal.vue?vue&type=template&id=ccfa226c&"
import script from "./CreateXNusantaraModal.vue?vue&type=script&lang=js&"
export * from "./CreateXNusantaraModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateXNusantaraModal.vue?vue&type=style&index=0&id=ccfa226c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports